import { BaseClass } from '/src/components/BaseClass.js';
import { ObjectCollection } from '/src/utils/dataStructures.js';
import { commonStyleSheet } from '/src/assets/css/commonStyleSheet.js';
const stylesheet = new CSSStyleSheet();
stylesheet.replaceSync(`
  :host {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: auto;
  }

  .list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex-grow: 1;
    color: white;
  }

   button {
    padding: 14px;
    background-color: var(--color-content-block);
    display: flex;
    justify-content: center;
    width: 100%;
    font-size: inherit;
    color: white;

    &.added {
      background-color: var(--color-focus);
    }
  }
`);
export class RChecklist extends BaseClass {
    constructor() {
        super();
        this.shadowRoot.adoptedStyleSheets.push(commonStyleSheet, stylesheet);
    }
    connectedCallback() {
        this.shadowRoot.innerHTML = `
        <ul class="list"></ul>
     `;
    }
    set options(v) {
        this.#options = v;
        this.shadowRoot.querySelector('.list').innerHTML = '';
        v.forEach(i => this.#renderItem(i, this.#addedItems.has(i.id)));
    }
    get options() {
        return this.#options;
    }
    set value(value) {
        this.#addedItems.clear();
        if (!this.#options?.length)
            return;
        const objs = this.#options.filter(({ id }) => {
            return value.includes(id);
        });
        objs.forEach(v => {
            this.#addedItems.add(v);
        });
        this.shadowRoot.querySelector('.list').innerHTML = '';
        this.#options.forEach(i => this.#renderItem(i, this.#addedItems.has(i.id)));
    }
    get value() {
        return this.#addedItems.getAll();
    }
    #addedItems = new ObjectCollection();
    #options;
    #processItemToggle($el, item) {
        if (this.hasAttribute('multiple'))
            this.#processMultipleToggle($el, item);
        else
            this.#processSingleToggle($el, item);
    }
    #processMultipleToggle($el, item) {
        if ($el.classList.contains('added')) {
            this.#addedItems.remove(item.id);
        }
        else {
            this.#addedItems.add(item);
        }
        $el.classList.toggle('added');
    }
    #processSingleToggle($el, item) {
        if ($el.classList.contains('added'))
            return;
        this.shadowRoot.querySelector('.added')?.classList.remove('added');
        this.#addedItems.clear();
        this.#addedItems.add(item);
        $el.classList.add('added');
    }
    #renderItem(item, hasAddedClass) {
        const $li = document.createElement('li');
        const $el = document.createElement('button');
        $el.classList.add('item');
        if (hasAddedClass)
            $el.classList.add('added');
        $el.innerText = item.title;
        $el.addEventListener('click', () => this.#processItemToggle($el, item));
        $li.append($el);
        this.shadowRoot.querySelector('.list').append($li);
    }
}
customElements.define('r-checklist', RChecklist);
